<template>
  <div>
    <div class="text-right mt-3 mb-3 pb-2">
      <span
        style="cursor: pointer"
        @click="expand = !expand"
      >
        <span style="font-size: medium;">
          تنظیمات ترتیب نمایش سطری اطلاعات
        </span>
        <AppIcon> mdi-chevron-down </AppIcon>
      </span>
    </div>
    <AppExpandTransition>
      <AppCard
        v-show="expand"
        :flat="true"
      >
        <AppTransitionGroup name="slide">            
          <AppSortingSearch
            v-for="(item, index) in model"
            :key="item.id"
            :model="item"
            :label="rowsLabel[index]"
            :items="items(index)"
            @deleted="deleteItem(index)"
          />
        </AppTransitionGroup>
        <v-btn
          color="#2969e3"
          class="pa-1 mt-2"
          depressed
          elevation="2"
          outlined
          :disabled="!model && model[model.length-1].property"
          @click="addRow()"
        >
          <AppIcon>mdi-plus</AppIcon>
          <span>افزودن ترتیب نمایش</span>
        </v-btn>
      </AppCard>
    </AppExpandTransition>
  </div>
</template>

<script>
import AppSortingSearch from "@/components/search/AppSortingSearch";
import AppExpandTransition from "@/components/library/container/AppExpandTransition";
import AppCard from "@/components/library/container/AppCard";
import AppTransitionGroup from "@/components/library/container/AppTransitionGroup";
import AppIcon from "@/components/library/common/AppIcon";

export default {
  name: "AbrPrioritySearch",
  components: {
    AppIcon,
    AppTransitionGroup,
    AppCard,
    AppExpandTransition,
    AppSortingSearch,
  },
  props: ["def", "model"], //model is array of {property, direction}; def is of type TAdvancedSearch
  data: () => ({
    rowsLabel: ["اول", "دوم", "سوم", "چهارم", "پنجم", "ششم"].map(
      (l) => `اولویت ${l}`
    ),
    expand: false,
  }),
  mounted() {
    this.$watch("model", nv => console.log(nv))
    console.log(this.$t("ECore.Cmn.OrdinalNumbers.First"))
  },
  created() {
  var priorityItems=this.def.searchResult.properties.filter(item =>  item.orderPriority)
  priorityItems=priorityItems.sort((p2,p1) => {return p2.orderPriority-p1.orderPriority})
  this.model.splice(0, 1);
  if(priorityItems.length>0)
  {
  for (let p of priorityItems)
    {
      if(p.orderType ){
      if( p.orderType.name.split(".").pop()==="otDesc")
      {
      this.model.push({ descending:true ,id: Symbol(),property: p.name});
      }
      else if ( p.orderType.name.split(".").pop()==="otAsc")
      {
      this.model.push({ descending:false ,id: Symbol(),property: p.name});
      }
    }else{
      this.model.push({ id: Symbol(),property: p.name});
      }
    } 
  }
  else{
    this.model.push({ id: Symbol()});
  } 
},
  destroyed(){
    for (let i in this.model)
        {
          this.model.splice(i, 1);
        }
  },
  methods: {
    items(index) {    
      return this.def.searchResult.properties
          .filter(sp => sp.name === this.model[index].property || !this.model.find((p) => sp.name === p.property));
    },
    addRow() {
      console.log("add row");
      this.model.push({
        id: Symbol(),
      });
      console.log(this.model)
    },
    deleteItem(id) {
      this.model.splice(id, 1);
    }
  },
};
</script>

<style scoped></style>
